<template>
    <div
        class="table-numberInput"
        style="display: flex; flex-direction: column; position: relative;"
    >
      <input
          v-model="item.values"
          :class="item.class"
          :disabled="item.disabled"
          :min="item.minValue"
          :max="item.maxValue"
          :float="item.float"
          :maxlength="item.maxLength"
          @input="valueCheck()"
      >
          <span
              v-if="item.description"
              class="input_description"
          >
            {{item.description}}
          </span>
    </div>
</template>
<script>
export default {
  name: 'NumberInput',
  props: ['item'],
  computed: {
    isContentsValid() {
      return this.item.values || 0
    }
  },
  methods: {
    floatCheck(obj) {
      let num_check = /^([0-9]*)[\.]?([0-9])?$/;

      return !!num_check.test(obj);
    },
    /*
            1. value에 숫자와 소수점을 제외한 문자가 있다면 삭제
            2. minValue 보다 작다면, minValue로 치환
            3. maxValue 보다 크다면, maxValue로 치환
            4. 소수점을 지정해 줬다면, 지정한 자리수까지만 표현
            5. 소수점을 0으로 지정해줬다면, 반올림해서 정수로 변환
         */
    valueCheck() {
      let tempValue = this.item.values.replace(/[^-\.0-9]/g, '');

      if (tempValue !== '-') {
        if (this.item?.values < this.item.minValue) {
          tempValue = this.item.minValue;
        }

        if (this.item?.values > this.item.maxValue) {
          tempValue = this.item.maxValue;
        }

        if (tempValue && this.item.float && !this.floatCheck(tempValue)) {
          // 소수점이 생기면, 지정한 자릿수까지만 표현
          let float = 1;
          for (let i = 0; i < this.item.float; i++) {
            float *= 10;
          }

          tempValue = Math.floor(tempValue * float) / float;
        } else if (tempValue && this.item.float === 0) {
          // 반올림해서 정수로 변환
          // . 은 0으로 치환
          tempValue = tempValue === '.' ? 0 : Math.floor(tempValue);
        }

        this.item.values = isNaN(tempValue) ? '' : tempValue;
      }
    },
    // getByte(str) {
    //     return str.split('').map(s => s.charCodeAt(0)).reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0);
    // }
  }
}
</script>
<style lang="scss" scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input_description {
  font-size: 11px;
  margin-top: 3px;
}

.table-numberInput {
  input:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>